import { MatchMediaContext, TIER } from '@george-labs.com/design-system';
import { useContext } from 'react';

import { useTemporaryMessagesState } from './useTemporaryMessagesState';
import { useIsTemporaryMessageDisplayed } from './useIsTemporaryMessageDisplayed';

const TEMPORARY_MESSAGES_HEIGHT = 120;
const TEMPORARY_MESSAGES_HEIGHT_DOWN_MD = 144;
export const TEMPORARY_MESSAGES_HEIGHT_COLLAPSED = 48;

const MD_DOWN_TIERS = [TIER.XS, TIER.SM, TIER.MD];

export function getTemporaryMessageHeaderHeight(tier: TIER): number {
    if (MD_DOWN_TIERS.includes(tier)) {
        return TEMPORARY_MESSAGES_HEIGHT_DOWN_MD;
    }

    return TEMPORARY_MESSAGES_HEIGHT;
}

export function useTemporaryMessageHeaderHeight(): number {
    const { isMessageCollapsed } = useTemporaryMessagesState();
    const { matchingTier } = useContext(MatchMediaContext);
    const isTemporaryMessageDisplayed = useIsTemporaryMessageDisplayed();

    if (!isTemporaryMessageDisplayed) {
        return 0;
    }

    if (isMessageCollapsed) {
        return TEMPORARY_MESSAGES_HEIGHT_COLLAPSED;
    }

    return getTemporaryMessageHeaderHeight(matchingTier);
}
